var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as documentAlertConfigData } from '@web/lib/demo/data/documentAlertConfig';
import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
import { DocumentTypeEnum } from '@workalizer/shared';
export var documentAlertConfig = function () {
    var response = documentAlertConfigData.map(function (item) {
        return __assign(__assign({}, item), { documentAlertConfigList: item.documentAlertConfigList.map(function (doc) {
                var _a;
                var document = (_a = documentEventsData.find(function (doc_item) { return doc_item.documentId === doc.documentId; })) === null || _a === void 0 ? void 0 : _a.document;
                return __assign(__assign({}, doc), { document: document
                        ? __assign(__assign({}, document), { ownerId: null }) : {
                        id: 0,
                        slugId: '0',
                        workspaceId: 1,
                        createdAt: new Date().toISOString(),
                        updatedAt: new Date().toISOString(),
                        type: DocumentTypeEnum.DOCUMENT,
                        title: doc.title,
                        ownerId: null
                    } });
            }) });
    });
    return response;
};
